<template>
  <div>
    <v-list>
      <ListItem
        :title="teacher.name"
        :subtitle="$t('fields.name')"
      />
      <ListItem
        :title="teacher.surname"
        :subtitle="$t('fields.surname')"
      />

      <ListItem
        :title="defaultAddress[0].street"
        :subtitle="$t('fields.address')"
      />

      <ListItem
        :title="defaultAddress[0].phone"
        :subtitle="$t('fields.phone')"
      />

      <ListItem
        :title="teacher.options.alternative_phone"
        :subtitle="$t('fields.alternative_phone')"
      />

      <ListItem
        :title="defaultAddress[0].email"
        :subtitle="$t('fields.email')"
      />

      <ListItem
        :title="teacher.options.alternative_email"
        :subtitle="$t('fields.alternative_email')"
      />

      <ListItem
        :title="teacher.options.bookshop"
        :subtitle="$t('fields.bookshop')"
      />

      <ListItem
        :title="teacher.options.notice_invisible"
        :subtitle="$t('fields.notice_invisible')"
      />

      <ListItem
        :title="teacher.options.notice_visible"
        :subtitle="$t('fields.notice_visible')"
      />

      <ListItem
        :title="$t(`fields.${teacher.options.privacy}`)"
        :subtitle="$t('fields.privacy')"
      />

    </v-list>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  import ListItem from '../../shared/Lists/ListItem';

  export default {
    name: 'TeacherDetails',
    components: { ListItem },
    props: {
      teacher: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        defaultAddress: {},
      };
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),
      getDefaultAddress() {
        this.defaultAddress = this.teacher.addresses.filter(
          (item) => item.options && item.options.is_default);
      },
    },
    created() {
      this.getDefaultAddress();
    },
  };
</script>
